import React from 'react';
import PropTypes from 'prop-types';
import ItemCounterButton from '../item-counter-button/item-counter-button';
import Messages from '../../constants/Messages';

const Item = (props) => {
    const {
        data, 
        updateQty,
        removeItem
    } = props;

    /** ----------------------------------------------------------------
     * Method to update the item quantity
     * @param {*} qty 
     */
    const updateCurrentValue = (quantity) => {
        updateQty(data, quantity);
    }

    /** ----------------------------------------------------------------
     * Method to update the item quantity
     * @param {*} qty 
     */
    const removeCurrentItem = () => {
        removeItem(data.id);
    }

    return (
        <div className='rounded-lg bg-white'>
            <div className="flex w-full p-4 mt-2 justify-between align-items">
                <div className="basis-2/3 text-sm mr-2">
                    <div className='font-medium leading-5'>{data.name}</div>
                    <div className='text-sm'>{Messages.CURRENCY.INR} {data.price}</div>
                </div>
                <div className="grow-0 text-right">
                    {
                        data.isRemovable ? (
                            <a className = 'text-sm font-bold text-red-500' onClick={removeCurrentItem}>{Messages.CART.REMOVE_ITEM}</a>
                        ) : <ItemCounterButton counter = {data.quantity ? data.quantity : 0} updateCurrentValue = {updateCurrentValue}/>
                    }
                    
                </div>
            </div>
            {
                data.isRemovable ? (
                    <div className="p-2 pl-4 border-t text-xs bg-red-700 rounded-b-lg text-white font-bold">
                       {Messages.CART.ITEM_NOT_AVAILABLE}
                    </div>
                ) : null
            }
            
        </div>
    )
}

Item.propTypes = {
    data: PropTypes.object, 
    updateQty : PropTypes.func,
    removeItem : PropTypes.func
};

export default Item;